import { StringRecordId, Surreal } from "surrealdb";

import { Image, imageSchema } from "../types/image";
import { ImageCreate } from "../types/image-create";
import { ImageUpdate } from "../types/image-update";
import { View, viewSchema } from "../types/view";
import { ViewUpdate } from "../types/view-update";

export async function getView({
  connection,
  code,
}: {
  connection: Surreal;
  code: string;
}): Promise<View> {
  const result = (
    await connection.query<unknown[][]>(
      `
      SELECT
        code,
        name,
        (SELECT
          id,
          file::get(file) AS bytes,
          title,
          order
        FROM image
        WHERE view.id = $parent.id
        ORDER BY order ASC
        ) AS images,
        createdAt,
        updatedAt
      FROM view WHERE code = $code
      `,
      { code },
    )
  )[0]?.[0];
  return viewSchema.parse(result);
}

export async function updateView({
  connection,
  code,
  view,
}: {
  connection: Surreal;
  code: string;
  view: ViewUpdate;
}) {
  await connection.query<unknown[][]>(
    `UPDATE view MERGE {$view} WHERE code = $code`,
    { code, view },
  );
}

export async function addImage({
  connection,
  code,
  image,
  fileName,
}: {
  connection: Surreal;
  code: string;
  image: ImageCreate;
  fileName: string;
}): Promise<Image> {
  const ext = fileName.split(".").pop()?.toLowerCase() ?? "jpg";
  const fileKey = `${crypto.randomUUID()}.${ext}`;

  const result = await connection.query<unknown[][]>(
    `
    BEGIN TRANSACTION;
      LET $file = type::file("assets", "/" + $code + "/" + $fileKey);
      $file.put($bytes);
      LET $view = (SELECT VALUE id FROM view WHERE code = $code LIMIT 1)[0];
      LET $image = (CREATE image CONTENT {
        view: $view,
        title: $title,
        file: $file,
        order: $order
      })[0];
      RETURN $image;

    COMMIT;
    SELECT
      id,
      file::get(file) AS bytes,
      title,
      order
    FROM $image;

    `,
    {
      fileKey,
      code,
      bytes: image.bytes,
      title: image.title,
      order: image.order,
    },
  );

  return imageSchema.parse(result[7]?.[0]);
}

export async function updateImage({
  connection,
  imageId,
  image,
}: {
  connection: Surreal;
  imageId: string;
  image: ImageUpdate;
}) {
  await connection.query<unknown[][]>(
    `UPDATE image MERGE $image WHERE id = $id`,
    { id: new StringRecordId(imageId), image },
  );
}

export async function deleteImage({
  connection,
  imageId,
}: {
  connection: Surreal;
  imageId: string;
}) {
  await connection.query<unknown[][]>(`DELETE $id`, {
    id: new StringRecordId(imageId),
  });
}
